export default __webpack_public_path__ + "static/media/55.ef907431.png";